import { Mail, Volume2 } from "lucide-react";
import { toast } from "sonner";
import { BottomNav, Logo } from "../../components/laxmi/Chrome";
import { useSite } from "../../lib/site";

const TILES = [["Popular", "popular", "wide"], ["Bingo", "bingo", "wide"], ["Casino", "casino"], ["Slots", "slots"], ["Sports", "sports"], ["Rummy", "rummy"], ["Fishing", "fishing"], ["Aviator", "aviator"]];
const PLATFORM = [["Live rooms", "p_live"], ["Lucky spin", "p_spin"], ["Hot games", "p_hot"]];

function Announcement({ text }) {
  return (
    <div className="announce-bar" data-testid="announcement"><Volume2 /><p className="announce-text">{text}</p>
      <button onClick={() => toast(text)} data-testid="announcement-detail-button">🔥 Detail</button></div>
  );
}

export { Announcement };

export default function Home({ data, setPage }) {
  const { site } = useSite();
  const soon = g => toast(`${g} is coming soon. Play WinGo now!`);
  const unread = data.notifications.filter(n => !n.read).length;
  return (
    <div className="screen home">
      <header className="home-header"><Logo /><button onClick={() => setPage("notifications")} data-testid="notifications-button"><Mail />{unread > 0 && <i className="dot-badge" />}</button></header>
      <div className="home-banner" onClick={() => setPage("deposit")} data-testid="home-banner"><img src="/assets/banner.jpg" alt="Laxmiwin bonus" /><div><b>Deposit ₹10,000</b><strong>Get +₹10,000</strong><small>₹15,000 deposit pe +₹15,000 · WinGo 1 Min</small></div></div>
      <Announcement text={site.announcement} />
      <button className="htile full" onClick={() => setPage("wingo")} data-testid="game-wingo-tile">
        <img src="/assets/wingo.jpg" alt="Win Go" /><div className="wingo-copy"><b>Win Go</b><small>Guess Number · Green / Violet / Red</small><em>Play now ›</em></div>
      </button>
      <div className="home-grid">{TILES.map(([g, img, cls]) => (
        <button key={g} className={`htile ${cls || ""}`} onClick={() => soon(g)} data-testid={`game-${g.toLowerCase()}-tile`}><img src={`/assets/${img}.jpg`} alt={g} /><b>{g}</b></button>))}
      </div>
      <h2 className="section-title">🔥 Platform <span>All ›</span></h2>
      <div className="platform-grid">{PLATFORM.map(([l, img]) => <button key={l} onClick={() => soon(l)} data-testid={`platform-${img}`}><img src={`/assets/${img}.jpg`} alt={l} /><b>{l}</b></button>)}</div>
      <BottomNav page="home" setPage={setPage} />
    </div>
  );
}
